import { AgentLanguage } from '../agent-language'

const newRules: { [key: string]: AgentLanguage[] } = {}

export function getIsNewRule(rule: string, language: AgentLanguage) {
  const newRule = newRules[rule]

  if (!newRule) {
    return false
  }

  return newRule.includes(language)
}
